export default __webpack_public_path__ + "static/media/women.6119e88f81940612eac17cfe8fdb1fce.png";